import React from "react";
import * as Icon from "react-bootstrap-icons";
import { useState, useEffect,useRef } from "react";
import { useDispatch } from "react-redux";
// import  Toast  from "../assetLibComponents/shared/Toast ";
import { addMessageQuery, fetchChatHistoryListing, setListingData } from "../../redux/actions/queryZoiAction";
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import storeApis from "../../api/storeApi";
import { initAudioContext } from "../../utils/audioUtils";

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/navigation';


// import required modules
import { EffectCoverflow, Pagination,Navigation } from 'swiper/modules';
import { useSelector } from "react-redux";
import axios from "axios";
import { speechToTextUrl, wsSpeech } from "../../utils/env";
import { getCustomerBranding, getRecommendedQuestions } from "../../api/customerSiaApi";


const Home = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authToken = props.authToken;
  const [promptMessage, setPromptMessage] = useState("");
  const [currentSliderQuestion, setCurrentSliderQuestion] = useState("What are some use cases for Salespanda in financial services ?");
  const chat_history = useSelector((state) => state.queryzoi.chat_history);
  const org_id = useSelector((state) => state.assetLibrary?.userData?.new_client_id);
  const [showSuggestions, setShowSuggestions] = useState(null);
  const textareaRef = useRef(null);
  const [apiSuggestions, setApiSuggestions] = useState([]);
  const [apiDisclaimer, setApiDisclaimer] = useState("");

  // Speech-to-text related states and refs
  const [isRecording, setIsRecording] = useState(false);
  const [transcribedText, setTranscribedText] = useState("");
  const [microphonePermission, setMicrophonePermission] = useState('unknown');
  const [sessionId, setSessionId] = useState(null);
  const [isConnected, setIsConnected] = useState(false);
  const [detectedLanguage, setDetectedLanguage] = useState(null);
  
  // Audio processing refs
  const audioSocketRef = useRef(null);
  const audioContextRef = useRef(null);
  const audioStreamRef = useRef(null);
  const audioProcessorRef = useRef(null);
  const audioSourceRef = useRef(null);
  const isRecordingRef = useRef(false);

  // Auto-resize textarea
  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = Math.min(textareaRef.current.scrollHeight, 120) + 'px';
    }
  }, [promptMessage]);

  useEffect(async () => {
    if (!authToken) return;
    const expiryDate = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000);
    const randomIdQuery = Math.floor(Math.random() * 900000) + 100000;
    Cookies.set("qzoi", `q-zoi-${randomIdQuery}`, { expires: expiryDate });
    dispatch(setListingData());
    const recResponse = await getRecommendedQuestions(authToken);
    if (recResponse?.data?.statusCode === "200") {
      const sections = recResponse.data.sections || [];
      const questionRows = recResponse.data.details || [];
      const grouped = sections
        .filter((section) => section.is_active !== false)
        .sort((a, b) => (a.priority || 0) - (b.priority || 0))
        .map((section) => ({
          id: section.id,
          name: section.name,
          questions: questionRows
            .filter(
              (q) =>
                q.section_id === section.id &&
                q.is_active !== false &&
                q.question &&
                q.question.trim() !== ""
            )
            .sort((a, b) => (a.priority || 0) - (b.priority || 0))
            .map((q) => q.question),
        }))
        .filter((section) => section.questions.length > 0);
      setApiSuggestions(grouped);
    } else {
      setApiSuggestions([]);
    }
    dispatch(fetchChatHistoryListing(authToken));
  }, [authToken])

  useEffect(() => {
    const loadDisclaimer = async () => {
      if (!authToken) return;
      try {
        const res = await getCustomerBranding(authToken);
        if (res?.data?.statusCode === "200") {
          setApiDisclaimer(res?.data?.data?.disclaimer || "");
        }
      } catch (_) {
        setApiDisclaimer("");
      }
    };
    loadDisclaimer();
  }, [authToken]);

  const [userData, setUserData] = useState(null);

  const hasAnySuggestions = Array.isArray(apiSuggestions) && apiSuggestions.length > 0;

  // URL-based: show disclaimer on allowed URLs when path contains internal_ama
  // Allowed: localhost:3000, 127.0.0.1:3000, dev.askzoi.com, sia.salespanda.com
  const isAllowedOrigin = () => {
    if (typeof window === 'undefined') return false;
    const { hostname, port, pathname } = window.location;
    const isInternalAma = pathname.includes('internal_ama');
    return isInternalAma;
    if (!isInternalAma) return false;
    // const isLocalhost = (hostname === 'localhost' || hostname === '127.0.0.1') && (port === '3000' || port === '');
    // const isDevAskzoi = hostname === 'dev.askzoi.com';
    // const isSiaSalespanda = hostname === 'sia.salespanda.com';
    // return isLocalhost || isDevAskzoi || isSiaSalespanda;
  };
  const showDisclaimer = isAllowedOrigin();

  useEffect(() => {
    const storedUserData = localStorage.getItem('userData');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
    
    // Check microphone permissions on component mount
    checkMicrophonePermissions();
  }, []);

  // Function to check microphone permissions
  const checkMicrophonePermissions = async () => {
    try {
      if (navigator.permissions) {
        const permissionStatus = await navigator.permissions.query({ name: 'microphone' });
        setMicrophonePermission(permissionStatus.state);
        console.log('Microphone permission status:', permissionStatus.state);
        
        permissionStatus.onchange = () => {
          setMicrophonePermission(permissionStatus.state);
          console.log('Microphone permission changed to:', permissionStatus.state);
        };
      } else {
        console.log('Permissions API not supported');
        setMicrophonePermission('unsupported');
      }
    } catch (error) {
      console.error('Error checking microphone permissions:', error);
      setMicrophonePermission('error');
    }
  };

  // Create session with the new Saaras API
  const createSession = async () => {
    try {
      console.log('📡 Creating Saaras session...');
      
      const response = await axios.post(
        speechToTextUrl(),
        { "user": "1"},
        {
          headers: {
            Accept: "application/json", 
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      if (response.status === 200 && response.data.status === 'success') {
        const newSessionId = response.data.session_id;
        setSessionId(newSessionId);
        console.log(`✅ Session created: ${newSessionId}`);
        return newSessionId;
      } else {
        throw new Error(response.data.message || 'Session creation failed');
      }
    } catch (error) {
      console.error('❌ Session creation error:', error);
      // Toast ("Failed to create speech session", "E");
      throw error;
    }
  };

  // WebSocket connection for Saaras API
  const connectWebSocket = async (sessionId) => {
    try {
      const wsURL = wsSpeech(sessionId);
      console.log(`🔗 Connecting to WebSocket: ${wsURL}`);

      const audioSocket = new WebSocket(wsURL);
      
      audioSocket.onopen = () => {
        console.log("✅ WebSocket connected");
        setIsConnected(true);
        audioSocketRef.current = audioSocket;
      };

      audioSocket.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          handleWebSocketMessage(data);
        } catch (error) {
          console.error('Error parsing WebSocket message:', error);
        }
      };

      audioSocket.onerror = (error) => {
        console.error('❌ WebSocket error:', error);
        setTimeout(() => {
          connectWebSocket(sessionId);
        }, 1000); 
        setIsConnected(false);
      };

      audioSocket.onclose = () => {
        console.log("🔌 WebSocket disconnected");
        setIsConnected(false);
        audioSocketRef.current = null;
      };

      return audioSocket;
    } catch (error) {
      setTimeout(() => {
        connectWebSocket(sessionId);
      }, 1000); 
      console.error('❌ WebSocket connection error:', error);
      // Toast ("Failed to connect to speech service", "E");
      throw error;
    }
  };

  // Handle WebSocket messages from new Saaras API
  const handleWebSocketMessage = (data) => {
    console.log(`📨 Received: ${data.type} - ${data.message || ''}`);

    switch (data.type) {
      case 'websocket_connected':
        console.log(`🎉 Connected to session: ${data.session_id}`);
        break;

      case 'recording_started':
        console.log("🔴 Recording with Saaras v2.5 streaming...");
        break;

      case 'speech_start':
        console.log("🎤 Speech detected");
        break;

      case 'speech_end':
        console.log("⏸️ Speech ended");
        break;

      case 'language_detected':
        setDetectedLanguage(data.language);
        console.log(`🌐 Language detected: ${data.language} (${data.language_code})`);
        break;

      case 'streaming_transcript':
        const liveText = data.full_transcript || data.transcript;
        setTranscribedText(liveText);
        setPromptMessage(liveText);
        
        // Adjust textarea height
        if (textareaRef.current) {
          const textarea = textareaRef.current;
          const scrollTop = textarea.scrollTop;
          textarea.style.height = 'auto';
          const scrollHeight = textarea.scrollHeight;
          const newHeight = liveText === '' ? 96 : Math.min(scrollHeight, 120);
          textarea.style.height = newHeight + 'px';
          textarea.scrollTop = scrollTop;
        }
        console.log(`📝 Live: ${data.transcript}`);
        break;

      case 'recording_stopped':
        console.log("⏹️ Recording stopped - Processing...");
        break;

      case 'transcription_result':
        const finalText = data.transcript;
        setTranscribedText(finalText);
        setPromptMessage(finalText);
        console.log(`🎯 Final result: ${finalText}`);
        if (data.streaming_source) {
          console.log("⚡ Result from Saaras streaming");
        }
        break;

      case 'streaming_error':
      case 'transcription_error':
        console.error(`❌ Error: ${data.message || data.error}`);
        // Toast (`Speech recognition error: ${data.message || data.error}`, "E");
        break;

      case 'chunk_received':
        // Silent - too frequent for UI
        break;

      default:
        console.log(`❓ Unknown message type: ${data.type}`);
    }
  };

  // Speech-to-text functions - Updated for new Saaras API
  const startRecording = async () => {
    try {
      console.log('🎤 Starting Saaras speech recognition...');
      
      // Check if navigator.mediaDevices is available
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('getUserMedia is not supported in this browser');
      }

      // Check if we're on HTTPS or localhost
      if (window.location.protocol !== 'https:' && window.location.hostname !== 'localhost' && window.location.hostname !== '127.0.0.1') {
        throw new Error('Microphone access requires HTTPS or localhost');
      }

      console.log('Requesting microphone permission...');
       
      // Request microphone permission with specific constraints for raw audio
      const stream = await navigator.mediaDevices.getUserMedia({ 
        audio: {
          sampleRate: 16000,
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: true
        } 
      });
      
      console.log('Microphone access granted, creating session...');

      // Create session and connect WebSocket (server doesn't support Socket.IO)
      const newSessionId = await createSession();
      
      // Use WebSocket directly since server doesn't support Socket.IO
      const audioSocket = await connectWebSocket(newSessionId);
      console.log('✅ Using WebSocket connection (server doesn\'t support Socket.IO)');
      
      // Wait for WebSocket to be ready
      if (audioSocket.readyState !== WebSocket.OPEN) {
        await new Promise((resolve, reject) => {
          const timeout = setTimeout(() => reject(new Error('WebSocket connection timeout')), 5000);
          audioSocket.onopen = () => {
            clearTimeout(timeout);
            resolve();
          };
        });
      }

      // Send start recording message
      audioSocket.send(JSON.stringify({ type: 'start_recording' }));

      // Create AudioContext for raw audio processing (iOS compatible)
      initAudioContext();
      const audioContext = new (window.AudioContext || window.webkitAudioContext)({
        sampleRate: 16000
      });
      
      const source = audioContext.createMediaStreamSource(stream);
      
      // Create ScriptProcessorNode for raw audio capture
      const processor = audioContext.createScriptProcessor(1024, 1, 1);
      
      processor.onaudioprocess = (event) => {
        if (audioSocket && audioSocket.readyState === WebSocket.OPEN && isRecordingRef.current) {
          const inputData = event.inputBuffer.getChannelData(0);
          
          // Convert float32 to int16 PCM
          const int16Array = new Int16Array(inputData.length);
          for (let i = 0; i < inputData.length; i++) {
            int16Array[i] = Math.max(-32768, Math.min(32767, Math.floor(inputData[i] * 32767)));
          }
          
          // Convert to base64 byte stream (like HTML template)
          const arrayBuffer = int16Array.buffer;
          const uint8Array = new Uint8Array(arrayBuffer);
          let binary = '';
          for (let i = 0; i < uint8Array.byteLength; i++) {
            binary += String.fromCharCode(uint8Array[i]);
          }
          const base64Data = btoa(binary);
          
          // Send via WebSocket
          audioSocket.send(JSON.stringify({
            type: 'audio_chunk',
            audio_data: base64Data
          }));
        }
      };

      source.connect(processor);
      processor.connect(audioContext.destination);
      
      // Store references for cleanup
      audioContextRef.current = audioContext;
      audioProcessorRef.current = processor;
      audioSourceRef.current = source;
      audioStreamRef.current = stream;
      isRecordingRef.current = true;
      setIsRecording(true);
      
      console.log('✅ Saaras speech recognition started successfully');

    } catch (err) {
      console.error("Error starting speech recognition:", err);
      
      // Provide specific error messages
      if (err.name === 'NotAllowedError') {
        // Toast ("Microphone access denied. Please allow microphone access and try again.", "E");
      } else if (err.name === 'NotFoundError') {
        // Toast ("No microphone found. Please connect a microphone and try again.", "E");
      } else if (err.name === 'NotSupportedError') {
        // Toast ("Microphone is not supported in this browser.", "E");
      } else if (err.name === 'NotReadableError') {
        // Toast ("Microphone is being used by another application.", "E");
      } else if (err.message.includes('HTTPS')) {
        // Toast ("Microphone access requires HTTPS. Please use a secure connection.", "E");
      } else {
        // Toast (`Speech recognition error: ${err.message}`, "E");
      }
    }
  };

  const stopRecording = () => {
    console.log('⏹️ Stopping Saaras speech recognition...');
    
    isRecordingRef.current = false;
    setIsRecording(false);
    
    // Send stop recording message
    if (audioSocketRef.current && audioSocketRef.current.readyState === WebSocket.OPEN) {
      audioSocketRef.current.send(JSON.stringify({ type: 'stop_recording' }));
      console.log('Sent stop_recording message to server');
    }
    
    // Clean up AudioContext and processor
    if (audioProcessorRef.current) {
      audioProcessorRef.current.disconnect();
      audioProcessorRef.current = null;
    }
    
    if (audioSourceRef.current) {
      audioSourceRef.current.disconnect();
      audioSourceRef.current = null;
    }
    
    if (audioContextRef.current) {
      audioContextRef.current.close();
      audioContextRef.current = null;
    }
    
    // Stop all audio tracks
    if (audioStreamRef.current) {
      audioStreamRef.current.getTracks().forEach(track => {
        track.stop();
        console.log('Stopped audio track:', track);
      });
      audioStreamRef.current = null;
    }
    
    console.log('🛑 Saaras speech recognition stopped successfully');
  };

  const toggleRecording = () => {
    if (isRecordingRef.current) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  // Cleanup on component unmount
  useEffect(() => {
    return () => {
      if (isRecordingRef.current) {
        stopRecording();
      }
      
      // Close WebSocket connection
      if (audioSocketRef.current) {
        audioSocketRef.current.close();
        console.log('WebSocket connection closed on unmount');
      }
      
      // Additional cleanup for audio context
      if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
        audioContextRef.current.close();
        console.log('Audio context closed on unmount');
      }
    };
  }, []);

  return (
    <div className="flex flex-col h-[80vh] max-sm:min-h-[90vh] max-sm:overflow-y-auto relative bg-white">
      {/* Header with Welcome and Create New */}
      <div className="flex flex-col justify-center items-center mx-auto mt-[10%] max-sm:mt-4 max-sm:mx-0 max-sm:h-auto max-sm:justify-start">
      <div className="flex justify-between mb-2 w-full mx-auto my-auto max-sm:m-0 max-sm:px-4">
        <div className="text-[var(--brand-primary)] font-bold text-xl max-sm:text-lg my-auto">Welcome {userData?.data?.first_name}!</div>
        {/* Debug info - remove in production */}
        {detectedLanguage && (
          <div className="text-xs max-sm:text-[10px] text-blue-600 bg-blue-100 px-2 py-1 max-sm:px-1.5 max-sm:py-0.5 rounded">
            🌐 {detectedLanguage}
          </div>
        )}
      </div>
              <div className="mt-2 max-sm:mt-1 max-sm:w-full">
          {/* Input Field with Arrow Button at bottom-right */}
          <div className="w-full flex my-6 max-sm:mb-2 mt-10 max-sm:mt-6 mx-auto justify-center max-sm:px-4">
            <div className="w-full mx-auto">
              <div className="bg-white relative flex flex-col border border-gray-300 rounded-lg w-full mx-auto p-0" style={{ minHeight: '56px' }}>
                <textarea
                  ref={textareaRef}
                  className="block w-full pl-4 max-sm:pl-3 pr-4 max-sm:pr-3 pt-4 max-sm:pt-3 pb-10 max-sm:pb-8 border-none rounded-lg focus:outline-none text-gray-700 bg-transparent text-base max-sm:text-sm placeholder-gray-400 resize-none overflow-y-auto"
                  placeholder="Ask anything...."
                  rows={1}
                  style={{ minHeight: '125px', maxHeight: '160px' }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" && !e.shiftKey && promptMessage !== "") {
                      e.preventDefault();
                      let token = Cookies.get("qzoi")
                      navigate(`/internal_ama/${token}`)
                      props.initialQuestion(promptMessage);
                    }
                  }}
                  value={promptMessage}
                  onChange={(e) => setPromptMessage(e.target.value)}
                />
                {/* Microphone Button */}
                <div className="bg-[#ffffff] absolute rounded-b-lg w-full bottom-0 flex justify-between px-2">
                    <button
                      onClick={toggleRecording}
                      className={`rounded-full p-2 max-sm:p-1.5 transition-colors ${
                        isRecording 
                          ? 'bg-transparent' 
                          : microphonePermission === 'denied'
                          ? 'bg-transparent cursor-not-allowed'
                          : 'bg-transparent'
                      }`}
                      aria-label={
                        microphonePermission === 'denied' 
                          ? "Microphone access denied" 
                          : isRecording 
                          ? "Stop Recording" 
                          : "Start Recording"
                      }
                      disabled={microphonePermission === 'denied'}
                      title={
                        microphonePermission === 'denied' 
                          ? "Please allow microphone access in your browser settings" 
                          : microphonePermission === 'prompt'
                          ? "Click to request microphone access"
                          : isRecording 
                          ? "Stop Recording" 
                          : "Start Recording"
                      }
                    >
                      {microphonePermission === 'denied' ? (
                        <Icon.MicMuteFill 
                          size={20} 
                          className="text-gray-400" 
                        />
                      ) : (
                        <Icon.MicFill 
                          size={20} 
                          className={isRecording ? "text-red-500" : "text-gray-600"} 
                        />
                      )}
                    </button>
                    {/* Send Button */}
                    <button
                      onClick={() => {
                        if (promptMessage !== "") {
                          let token = Cookies.get("qzoi")
                          navigate(`/internal_ama/${token}`)
                          props.initialQuestion(promptMessage);
                        } else {
                          // Toast ("AMA input field should not be empty","E")
                        }
                      }}
                      className="bg-white rounded-full p-2 max-sm:p-1.5 hover:bg-gray-100 transition-colors"
                      aria-label="Send"
                    >
                      <Icon.ArrowRightCircleFill size={28} className="text-black" />
                    </button>
                  </div>
            </div>
          </div>
        </div>
        {/* Action Buttons Row */}
        {!showSuggestions && hasAnySuggestions && (
          <div className="flex justify-center gap-4 max-sm:gap-0 max-sm:flex-col max-sm:space-y-2 mt-2 mb-8 max-sm:mb-6 flex-wrap max-w-[840pmax-sm:x] max-sm:max-w-full max-sm:px-4">
            {apiSuggestions.map((section) => (
              <button 
                key={section.id}
                className="flex items-center gap-2 max-sm:gap-1 border border-gray-300 rounded-full px-4 max-sm:px-3 py-2 max-sm:py-1.5 text-sm max-sm:text-xs font-medium bg-white hover:bg-gray-50 max-sm:w-full max-sm:justify-start"
                onClick={() => showSuggestions === section.id ? setShowSuggestions(null) : setShowSuggestions(section.id)}
              >
                <Icon.GeoAltFill className="text-[var(--brand-primary)]" size={18} />
                <span className="max-sm:hidden">{section.name}</span>
                <span className="hidden max-sm:inline">{section.name}</span>
              </button>
            ))}
          </div>
        )}
        {/* Suggestion */}
        <div className={`flex min-w-[830px] max-sm:min-w-full max-sm:px-4 transition-all duration-300 ease-in-out ${showSuggestions ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
          {showSuggestions && (
            <div className="w-full relative max-sm:w-full text-black">
              <div className="bg-white p-4 max-sm:p-3 rounded-lg">
                <div className="space-y-2 max-sm:space-y-1.5">
                  {showSuggestions &&
                    (apiSuggestions.find((section) => section.id === showSuggestions)?.questions || []).map((q, idx) => (
                    <div
                      key={`${showSuggestions}-${idx}`}
                      className="text-sm max-sm:text-xs text-gray-600 rounded-sm shadow-md hover:bg-gray-50 p-3 max-sm:p-2 cursor-pointer max-sm:block max-sm:w-full"
                      onClick={() => { setPromptMessage(q); setShowSuggestions(null); }}
                    >
                      {q}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Disclaimer - shown below suggestion question when open, URL-based (localhost:3000 allowed) */}
        {apiDisclaimer && showDisclaimer && (
          <div className="w-full max-w-[830px] max-sm:max-w-full max-sm:px-4 mt-4">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 max-sm:p-3 text-xs max-sm:text-[11px] text-gray-600 leading-relaxed">
              <p className="font-semibold text-gray-700 mb-2">Disclaimer:</p>
              {apiDisclaimer && (
                <p className="whitespace-pre-line">{apiDisclaimer}</p>
              )}
            </div>
          </div>
        )}
                
            
      </div>
      </div>
    </div>
  );
};

export default Home;
